import { memo } from "react"

import { DateMessage } from "./dateMessage"

export default memo(DateMessage)
